import { render, staticRenderFns } from "./LinkForm.vue?vue&type=template&id=3810f79e&scoped=true"
import script from "./LinkForm.vue?vue&type=script&lang=js"
export * from "./LinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3810f79e",
  null
  
)

export default component.exports